import React, { useState, useEffect } from "react";
import "./Wingo_modal.css";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GetAllPeriodHistory, GetHowToPlay } from "../../../../../features/games/color_prediction/Slice";
import parse from "html-react-parser";
function Wingo_modal({ mainActiveTab, ...props }) {
  const dispatch = useDispatch()
  const howToPlay = useSelector((state) => state.games.color_prediction.how_to_data);

  const fetch = async (page) => {
    await dispatch(GetHowToPlay())
  }


  useEffect(() => {
    fetch(1)
  }, [dispatch])

  return (
    <>
      <Modal
        {...props}
        centered
        size="sm"
        backdrop="static"
        className="Wingo_modal Common_modal"
        scrollable
      >
        <Modal.Body>
          <div className="upi_container">
            <div className="modal_header ">Wingo {mainActiveTab?.label}</div>

            <div className="content_holder">
              {parse(howToPlay?.description || "")}
              <div className="button_wrapper">
                <Button className="btn_register_bg" onClick={props.onHide}>Close</Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Wingo_modal;
